<template>
    <div class="mt-16" v-if="pronto">
      <v-card :class="$root.$vuetify.theme.isDark ? 'secondary' : ''" class="py-4 px-4">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="submit">
            <v-progress-linear v-if="loading" indeterminate class="global-loader" />
  
            <!-- Botão para abrir a câmara -->
            <v-row>
              <v-col cols="12" md="3">
                <v-btn color="primary" @click="openCamera">
                  {{$t(capturedImage || fields.invoice_url ? 'expenses.change_invoice' : 'expenses.attach_invoice')}} 
                  <v-icon right>mdi-camera-outline</v-icon>
                </v-btn>
              </v-col>           
  
              <!-- Preview da imagem capturada -->
              <v-col cols="12" md="9">
                <v-img
                  v-if="capturedImage || fields.invoice_url"
                  :src="capturedImage || fields.invoice_url"
                  max-width="200"
                  class="mt-12"
                  @click="dialogImage = true"
                  style="cursor: pointer"
                />
              </v-col>
            </v-row>

            <!--Botao aprovar-->
            <v-row class="mt-6 mb-6">
              <v-col cols="12" class="d-flex justify-end" v-if="pegasusResponse || fields.invoice_url">
                <v-chip v-if="fields.status === 'A'" color="success" outlined dark>
                  {{ $t('expenses.approved') }}
                </v-chip>
                <v-btn 
                  v-else-if="$root.session.hasPermission(['super', 'expenses.approve']) && fields.id"
                  color="success" 
                  @click="openApproveDialog"
                >
                  {{$t('expenses.approve')}}
                  <v-icon right>mdi-check</v-icon>
                </v-btn>
              </v-col>
            </v-row>
  
            <!-- Modal da câmara -->
            <v-dialog v-model="isCameraActive" max-width="600">
              <v-card class="pa-4 d-flex flex-column align-center">
                <video ref="video" autoplay playsinline style="width: 100%; border-radius: 8px;"></video>
                <v-row class="mt-4" justify="center">
                  <v-btn color="success" class="mr-4" @click="capturePhoto">{{$t('expenses.take_photo')}}</v-btn>
                  <v-btn color="error" @click="stopCamera">{{$t('globals.cancel')}}</v-btn>
                </v-row>
              </v-card>
            </v-dialog>
  
            <!-- Dialog para imagem em tamanho grande -->
            <v-dialog v-model="dialogImage" max-width="600">
              <v-card>
                <v-img :src="capturedImage || fields.invoice_url" contain height="500px" />
              </v-card>
            </v-dialog>
  
            <!-- Formulário -->
            <fieldset v-if="pegasusResponse || fields.invoice_url" :disabled="loading">
              <v-row>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" vid="data_fatura" :name="$t('expenses.invoice_date')" rules="required">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fields.data_fatura"
                          :label="$t('expenses.invoice_date') + ' *'"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        />
                      </template>
                      <v-date-picker v-model="fields.data_fatura" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </validation-provider>
                </v-col>
  
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" vid="n_fatura" :name="$t('expenses.invoice_number')" rules="required">
                    <v-text-field
                      v-model="fields.n_fatura"
                      prepend-inner-icon="mdi-file"
                      :label="$t('expenses.invoice_number') + ' *'"
                      clearable
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
  
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" vid="valor_fatura" :name="$t('expenses.invoice_value')" rules="required|min_value:0">
                    <v-currency-field
                      v-model="fields.valor_fatura"
                      :prepend-inner-icon="$currency_icon()"
                      :label="$t('expenses.invoice_value') + ' *'"
                      clearable
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
  
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" vid="classification_id" :name="$t('expenses.document_type')" rules="required">
                    <v-select
                      v-model="fields.classification_id"
                      :items="classificacoes"
                      :item-text="item=>item.description"
                      item-value="id"
                      :label="$t('expenses.document_type') + ' *'"
                      prepend-inner-icon="mdi-file-document"
                      clearable
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
  
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="fields.fornecedor"
                    prepend-inner-icon="mdi-truck"
                    :label="$t('globals.supplier')"
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="fields.work_id"
                    :items="works"
                    :item-text="item=>item.code + ' - ' + item.name"
                    item-value="id"
                    prepend-inner-icon="mdi-crane"
                    :label="$t('globals.works')"
                    clearable
                  />
                </v-col>
  
                <v-col cols="12">
                  <v-textarea
                    v-model="fields.nota"
                    :label="$t('expenses.notes')"
                    prepend-inner-icon="mdi-note-text"
                    clearable
                  />
                </v-col>
              </v-row>
  
              <!---Botao de gravar-->
              <v-row class="mt-6" align="center" justify="space-around" v-if="fields.status !== 'A'">
                <v-btn :disabled="invalid" depressed :class="$root.$vuetify.theme.isDark ? 'white primary--text' : 'primary'" type="submit">
                  {{$t('globals.save')}}
                </v-btn>
              </v-row>
            </fieldset>
  
            <DialogSuccess :opened="success" @on-ok="onSuccess">
              {{$t('expenses.saved_successfully')}}
            </DialogSuccess>
  
            <ErrorSnackbar v-model="error.show" :message="error.message" />

            <DialogConfirmation 
              :title="$t('expenses.confirm_approve_message')" 
              type="info"
              :opened="confirmApprove"
              @on-submit="approveExpense"
              @on-cancel="confirmApprove = false"
            >
              {{$t('expenses.confirm_approve_message')}}
            </DialogConfirmation>

          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </template>
  
  <script>
  import DialogSuccess from '@/components/ui/DialogSuccess.vue';
  import ErrorSnackbar from '@/components/ui/ErrorSnackbar.vue';
  import Work from '@/api/Work.js';
  import Expenses from '@/api/Expenses.js';
  import DialogConfirmation from '@/components/ui/DialogConfirmation.vue';
  
  export default {
    components: { 
      DialogSuccess, 
      ErrorSnackbar,
      DialogConfirmation, 
    },
    props: {
      expense: Object,
      method: String
    },
    data() {
      return {
        loading: false,
        success: false,
        menu: false,
        isCameraActive: false,
        dialogImage: false,
        capturedImage: null,
        videoStream: null,
        document_types: [],
        error: { show: false, message: '' },
        fields: {
          data_fatura: null,
          n_fatura: null,
          valor_fatura: null,
          fornecedor: null,
          classification_id: null,
          nota: null,
          work_id: null,
        },
        classificacoes: [],
        works: [],
        pronto: false,
        confirmApprove: false,
        pegasusResponse: null,

      }
    },
    watch: {
      expense: {
        immediate: true,
        handler(val) {
          if (val == null) return;
          this.fields = { ...val };
          if (val.work_id) {
            this.fields.work_id = String(val.work_id);
          }
        }
      }
    },

    async mounted() {
      await this.fillBaseData();

      const id = this.$route.params.id;
      if (this.method === 'update' && id) {
        await this.loadExpense(id);
      }

      this.pronto = true;
    },

    methods: {
      async fillBaseData() {

        const worksResp = await Work.list();

        const typesResp = await Expenses.getTypes();

        this.works = worksResp.data.map(w => ({
          ...w,
          id: String(w.id) 
        }));

        this.classificacoes = typesResp.data;

      },
      async loadExpense(id) {
        this.loading = true;
        try {
          const { data } = await Expenses.get(id);
          this.fields = {
            ...data,
            work_id: data.work_id ? String(data.work_id) : null
          };

        } catch (err) {
          console.error('Erro ao carregar despesa:', err);
        } finally {
          this.loading = false;
        }
      },
      openCamera() {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }})
          .then(stream => {
            this.videoStream = stream;
            this.isCameraActive = true;
            this.$nextTick(() => {
              this.$refs.video.srcObject = stream;
            });
          })
          .catch(err => {
            console.log('Erro ao aceder à câmara: ', err);
            this.error.show = true;
            this.error.message = 'Erro ao aceder à câmara';
          });
      },
      async capturePhoto() {
        const video = this.$refs.video;
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        //this.capturedImage = canvas.toDataURL('image/jpeg');
        //this.stopCamera();
        const dataUrl = canvas.toDataURL("image/jpeg");
        this.capturedImage = dataUrl;
        this.stopCamera();

        // Converter base64 para Blob
        const blob = this.dataURLtoBlob(dataUrl);

        // Guardar como "ficheiro" para enviar
        const file = new File([blob], "fatura.jpg", { type: "image/jpeg" });

        // Criar o FormData
        const formData = new FormData();
        formData.append("fatura", file); // o nome 'fatura' deve corresponder ao esperado no backend

        // Podes adicionar outros campos se quiseres:
        // formData.append("outro_campo", "valor");

        // Enviar para o backend
        this.loading = true

        this.pegasusResponse = true //apagar quando o backend estiver pronto
        this.loading = false //apagar quando o backend estiver pronto

        /* DESCOMENTAR QUANDO O BACKEND ESTIVER PRONTO
        await Expenses.pegasusConnection(formData).then((resp) => {
          console.log("Foto enviada com sucesso:", resp);
          this.pegasusResponse = true
          this.loading = false
        });
        */
    
      },
      stopCamera() {
        if (this.videoStream) {
          this.videoStream.getTracks().forEach(track => track.stop());
          this.videoStream = null;
        }
        this.isCameraActive = false;
      },
      submit() {
        const formData = new FormData();
            for (const key in this.fields) {
                if (this.fields[key] !== null && this.fields[key] !== undefined) {
                formData.append(key, this.fields[key]);
                }
            }
            formData.append("fatura", this.capturedImage);

            const tenant_id = this.$session.get('domain'); 
            formData.append('tenant_id', tenant_id);

            console.log('Enviar para o backend fields', this.fields);
            console.log('Enviar para o backend formData', formData);

        Expenses[this.method](formData, this.fields.id).then(() => {
            if(this.method=='create')
            this.$router.push('/' + this.$session.get('domain') + '/admin/expenses')
            else //window.location.reload()
            console.log("UPDATE: ", this.fields)
            this.success = true;
          
        }).catch((error) => {
            this.error.show = true;

            if (error.response.data.message == 'noworker') {
              this.error.message = "Este utilizador não tem colaborador associado."
            } else {
            this.error.message = "ERROR";
            console.log('Erro ao enviar os dados: ', error);
            }
          });

      },
      onSuccess() {
        this.success = false;
        this.$router.push('/' + this.$session.get('domain') + '/admin/expenses');
      },
      openApproveDialog() {
        this.confirmApprove = true;
      },
      async approveExpense() {
        this.confirmApprove = false;
        console.log("APROVADO");
        
        try {
          this.loading = true;
          await Expenses.approve(this.fields.id);  
          this.success = true;
        } catch (error) {
          this.error.show = true;
          this.error.message = this.$t('global_messages.error_approving');
          console.error('Erro ao aprovar despesa:', error);
        } finally {
          this.loading = false;
        }
          
      },
      dataURLtoBlob(dataURL) {
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], { type: mimeString });
      },

    }
  }
  </script>